




















































import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import { ICustomer, ICustomerAddress } from '@/interfaces';
import SuperCustomerEditor from "../invoices/super-customer-editor.vue";

import {
  RimRepairCustomerFormComponent,
  QbInfoComponent,
} from "@/components/common";

// import axios from "axios";
// import * as CL from "../Mtc_classes";
// import { MtcADMIN } from "../Mtc";
// import AdminTemplate from "../../../dev/Components/AdminTemplate.vue";
// import AdminTitles from "../../../dev/Components/AdminTitles.vue";

@Component({
  components: { SuperCustomerEditor, RimRepairCustomerFormComponent,QbInfoComponent}
})
export default class CustomerTabs extends Vue {
  constructor() {
    super();
  }

  /* LIFECYCLE METHODS */
	// mounted(){}
	// created(){}

	/* PROPS VARIABLES, They have to be lower case, or first capital only, 
		otherwise they will fail ! */
  @Prop()
  public value: ICustomer;


  /* PRIVATE VARIABLES, __ POSTFIXED */
  // private myVar__: any;

	/* VUE DATA */
  public Customer: ICustomer = null;
	public Tab: number | null = null;
  // public IsValid:boolean = true;
	

  /* VUE WATCH */
  @Watch("value", {immediate: true})
  onValueChanged(newVal: any, oldVal: any) {
		this.Customer=newVal;
	}

  /* VUE COMPUTED METHODS */
  // get date(): Date {
  //   return new Date();
  // }

  /* PRIVATE METHODS */
  // private MyFunction():void{}

  /* VUE METHODS */

  public CopyFromBilling(): void {
		this.Copy(this.Customer.Billing, this.Customer.Shipping);

		/// BILLING ADDRESS IS STORED ON BILLING.ADDRESS2, 
		/// THEREFORE BILLING.ADDRESS2 NEEDS TO BE COPIED TO SHIPPING.ADDRESS. 
		/// BILLING ADDRESS1 IS CUSTOMER NAME, WE DON'T TOUCH/COPY THAT FIELD
		this.Customer.Shipping.Address = this.Customer.Billing.Address2;
  }

  public CopyFromShipping(): void {
		this.Copy(this.Customer.Shipping, this.Customer.Billing);

		/// SHIPPING ADDRESS GOES TO BILLING ADDRESS2.
		/// BILLING ADDRESS1 IS CUSTOMER NAME, WE DON'T TOUCH THAT FIELD
		this.Customer.Billing.Address2 = this.Customer.Shipping.Address;
	}
	
	private Copy(s:ICustomerAddress, t:ICustomerAddress){
		t.FName = s.FName;
		t.LName = s.LName;
		t.Email = s.Email;
		t.Phone = s.Phone;
		t.Mobile = s.Mobile;
		// t.Address = s.Address;
		// t.Address2 = s.Address2;
		t.City = s.City;
		t.State = s.State;
		t.Zip = s.Zip;
	}

}
